import { styled } from "@linaria/react";
import { FinancialTimes } from "components/icons";
import RootThemedLayout from "components/RootThemedLayout";
import Svg from "components/Svg";
import DesktopHeader from "features/Header/DesktopHeader";
import { WithClassNameProps } from "interfaces";
import React from "react";
import { down, up } from "styles/utils/breakpoints";


import BanerImage from "./BanerImage";

interface BaseBannerProps {
  children?: React.ReactNode;
  ft?: boolean;
  bgColor?: string
}

const Empty = (props: WithClassNameProps) => {
  return <div {...props} />;
};


const PlanVistFooter = styled.footer`
  width: 100%;
  position: fixed;
  bottom: 0;
  display: flex;
  align-items: center;

  padding: 0 40px;
  height: 70px;
`;

const FT = styled(Svg)`
  font-size: 40px;
  flex-grow: 1;
  flex-shrink: 1;
  svg {
    &.GlobalMedia {
      margin-bottom: -34px;
    }
  }
`;  

const Content: any = styled.div`
  position: absolute;
  width: 100%;
  height: calc(100vh - 145px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;

  background-color: ${props => props.bgColor || '#fff'};

  ${up('lg')} {
    padding-block: 28px;
  }

  ${down('lg')} {
    padding: 92px 18px;
  }
  * {
    z-index: 1;
  }
`;

const Wrapper = styled.div`
  position: relative;

  .img {
    position: absolute;
    height: calc(100vh - 145px);
    top: 75px;
    width: 100%;
    z-index: 0;
  }

`

const WaitingHeader = styled(DesktopHeader)`
  border-bottom: none;
`

const BaseBanner = ({ children, ft = true, bgColor }: BaseBannerProps) => {
  return (
    <RootThemedLayout>
      <Wrapper>
        <BanerImage className="img"/>
        <WaitingHeader Controls={Empty} />
        <Content bgColor={bgColor}>{children}</Content>
        <PlanVistFooter>
          <FT>{ft && <FinancialTimes height="54" />}</FT>
        </PlanVistFooter>
      </Wrapper>
    </RootThemedLayout>
  );
};

export default BaseBanner;
